import React, { PropTypes } from 'react'
import { Link } from 'react-router'
import CSSModules from 'react-css-modules'

import styles from './navigation.css'

function renderItem(item, index, pathName) {
  return (
    <li
      key={index}
      styleName={`item-${item.type}`}
    >
      {
        item.subitems
          ? <div>
            <span styleName="link-inactive">{item.label}</span>
            <ul styleName="subnavigation">
              {item.subitems.map((subitem, subitemIndex) => renderItem(subitem, subitemIndex, pathName))}
            </ul>
          </div>
          : (
              item.path && (
                item.external
                ? <a href={item.path} styleName={pathName.match(item.match) ? 'link-active' : 'link-inactive'}>
                  {item.label}
                </a>
                : <Link
                  to={item.path}
                  styleName={pathName.match(item.match) ? 'link-active' : 'link-inactive'}
                >
                  {item.label}
                </Link>
              )
            )
      }
    </li>
  )
}

const Navigation = ({ items, pathName }) => (
  <ul styleName="navigation">
    {items && items.map((item, index) => renderItem(item, index, pathName))}
  </ul>
)

Navigation.propTypes = {
  items: PropTypes.array,
  pathName: PropTypes.string,
}

export default CSSModules(Navigation, styles, { allowMultiple: true })



/** WEBPACK FOOTER **
 ** ./src/components/navigation/navigation.js
 **/